
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"21","height":"21","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#F26522","stroke-width":"2.4","fill":"none","fill-rule":"evenodd","stroke-linecap":"square"}},[_c('path',{attrs:{"d":"M1.743 1.743l17.559 17.559M1.743 19.257L19.302 1.698"}})])])
      }
    
      }
    